import { render, staticRenderFns } from "./FAQNextAndroid.vue?vue&type=template&id=1b1957ea&scoped=true"
import script from "./FAQNextAndroid.vue?vue&type=script&lang=js"
export * from "./FAQNextAndroid.vue?vue&type=script&lang=js"
import style0 from "./FAQNextAndroid.vue?vue&type=style&index=0&id=1b1957ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1957ea",
  null
  
)

export default component.exports